import React, { useEffect, useState } from "react";
import { Modal, Table, Select, Tooltip, DatePicker, Button, Switch } from "antd";
import "./CalculationModal.css";
import { DownOutlined, EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { axiosInstance } from "../../../utils/axiosInterceptor";
import AdvanCapitalModal from "./AdvanCapitalModal";
const { Option } = Select;

// const TooltipTable = ({ data }) => (
//   <div
//     style={{ maxHeight: "295px"}}
//     className="custom-scrollbar overflow-x-auto overflow-y-auto"
//   >
//     <table className="min-w-[500px] border-collapse font-sans w-full">
//       <thead>
//         <tr className="bg-[#000833] sticky top-0 z-50">
//           {["category", "parameter", "lower_limit", "upper_limit", "rebate_value"].map(
//             (head, i) => (
//               <th
//                 key={i}
//                 className="px-3 py-2 border text-center font-semibold text-white text-sm bg-[#000833]"
//               >
//                 {head}
//               </th>
//             )
//           )}
//         </tr>
//       </thead>
//       <tbody>
//         {data?.map((tier, index) => (
//           <tr
//             key={index}
//             className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//           >
//             <td className="px-3 py-2 border text-center text-gray-600 text-sm whitespace-nowrap font-medium">
//               {tier?.category}
//             </td>
//             <td className="px-3 py-2 border text-center text-gray-600 text-sm whitespace-nowrap font-medium">
//               {tier?.parameter}
//             </td>
//             <td className="px-3 py-2 border text-center text-gray-600 text-sm whitespace-nowrap font-medium">
//               {tier?.lower_limit.toFixed(2)}%
//             </td>
//             <td className="px-3 py-2 border text-center text-gray-600 text-sm whitespace-nowrap font-medium">
//               {tier?.upper_limit.toFixed(2)}%
//             </td>
//             <td className="px-3 py-2 border text-center text-gray-600 text-sm whitespace-nowrap font-medium">
//               {tier?.rebate_value.toFixed(2)}%
//             </td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

export const prepareTableDataquarter = (tiers) => {
  // console.log(tiers)
  // Get unique ranges
  const ranges = {};

  tiers.forEach((tier) => {
    const rangeKey = `${tier.lower_limit}-${tier.upper_limit}`;
    if (!ranges[rangeKey]) {
      ranges[rangeKey] = {
        key: rangeKey,
        range: `${tier.lower_limit.toFixed(2)}% - ${tier.upper_limit.toFixed(
          2
        )}%`,
        brandGCR: null,
        brandScrubbed: null,
        genericScrubbed: null,
      };
    }

    if (tier.category === "Brand" && tier.parameter === "GLP-1 COGS") {
      ranges[rangeKey].brandglpcogs = tier.rebate_value;
    } else if (tier.category === "Brand" && tier.parameter === "Bx COGs") {
      ranges[rangeKey].brandbxcogs = tier.rebate_value;
    } else if (tier.category === "Brand" && tier.parameter === "GPR") {
      ranges[rangeKey].brandgpr = tier.rebate_value;
    } else if (tier.category === "OneStop" && tier.parameter === "GPR") {
      ranges[rangeKey].genericgpr = tier.rebate_value;
    }
  });

  return Object.values(ranges);
};

export const QuarterTooltipTable = ({ data }) => {
  const columns = [
    {
      title: "Range (%)",
      dataIndex: "range",
      key: "range",
      align: "center",
      width: 200,
    },
    {
      title: "Brand - Bx COGs",
      dataIndex: "brandbxcogs",
      key: "brandbxcogs",
      align: "center",
      render: (val) => (val !== null && val !== undefined ? `${val}%` : "-"),
      width: 160,
    },
    {
      title: "Brand - GLP-1 COGS",
      dataIndex: "brandglpcogs",
      key: "brandglpcogs",
      align: "center",
      render: (val) => (val !== null && val !== undefined ? `${val}%` : "-"),
      width: 160,
    },
    // {
    //   title: "Brand – GPR",
    //   dataIndex: "brandgpr",
    //   key: "brandgpr",
    //   align: "center",
    //   render: (val) => (val !== null && val !== undefined ? `${val}%` : "-"),
    //   width: 170
    // },
    // {
    //   title: "Generic – GPR",
    //   dataIndex: "genericgpr",
    //   key: "genericgpr",
    //   align: "center",
    //   render: (val) => (val !== null && val !== undefined ? `${val}%` : "-"),
    //   width: 170
    // },
  ];

  return (
    <div
      className="overflow-x-auto scrollbar-hide"
      style={{ maxWidth: "100%" }}
    >
      <Table
        dataSource={prepareTableDataquarter(data)}
        columns={columns}
        size="small"
        bordered
        pagination={false}
        rowKey={(record, idx) => idx}
        scroll={{ x: 500, y: 250 }}
        className="border-table custom-table user-tbl scrollbar-hide custom-scrollbar"
        style={{ width: "100%" }}
      />
    </div>
  );
};

export const GCRTooltipTable = ({ data ,flag}) => {
  const columns = [
    {
      title: "Range (%)",
      dataIndex: "range",
      key: "range",
      align: "center",
      width: 200,
    },
    {
      title: "Brand - Bx COGs",
      dataIndex: "brandbxcogs",
      key: "brandbxcogs",
      align: "center",
      render: (val) => (val !== null && val !== undefined ? `${val}%` : "-"),
      width: 160,
    },
    {
      title: "Brand - GLP-1 COGS",
      dataIndex: "brandglpcogs",
      key: "brandglpcogs",
      align: "center",
      render: (val) => (val !== null && val !== undefined ? `${val}%` : "-"),
      width: 160,
    },
  ];
  const cogsData = [
  {
    key: "cogs",
    term: "COGs",
    description: (
      <>
        Cost of Goods.
        <br />
        The discount off WAC on Brand Rx purchases calculated based on your GCR compliance tier achieved in the previous quarter.
      </>
    ),
  },
  {
    key: "cogsImpact",
    term: "COGs Impact",
    description:
      "The difference between Current COGs and Trending COGs and is based upon your last quarter's rebatable brand.",
  },
  {
    key: "trendingCogs",
    term: "Trending COGs",
    description:
      "Based on the current quarter's GCR, allowing you to view where your COGs are trending for next quarter.",
  },
  {
    key: "currentCogs",
    term: "Current COGs",
    description:
      "Your pharmacy's current percentage off of WAC for Brand Rx based on last quarters GCR%.  (Not including GLP1, Specialty or HIV).  The new COGs goes into effect one month after the end of the quarter.",
  },
];

const gcrData= [
  {
    key: "gcr",
    term: "GCR",
    description: (
      <>
        Generic Compliance Ratio. <br />Generic Rx $ divided by Total Rx $ (not including HIV).
      </>
    ),
  }
]
const gcrColumn = [
   {
    title: null,
    dataIndex: "term",
    key: "term",
    render: (text) => (
      <span className="font-medium text-black">{text}</span>
    ),
  },
   {
    title: null,
    dataIndex: "description",
    key: "description",
    render: (text) => (
      <span className="text-sm text-black">{text}</span>
    ),
  },
]
const newColumns = [
  {
    title: null,
    dataIndex: "term",
    key: "term",
    width: 130,
    render: (text) => (
      <span className="font-medium text-black">{text}</span>
    ),
  },
  {
    title: null,
    dataIndex: "description",
    key: "description",
    render: (text) => (
      <span className="text-sm text-black">{text}</span>
    ),
  },
];

  return (
    <div
      className="overflow-x-auto scrollbar-hide bg-white rounded-md"
      style={{ maxWidth: "100%" }}
    >
      { flag == "Gcr" ?
      <Table
        columns={gcrColumn}
        dataSource={gcrData}
        pagination={false}
        showHeader={false}
        bordered
        size="middle"
      />
      :
      <Table
  columns={newColumns}
  dataSource={cogsData}
  pagination={false}
  showHeader={false}
  bordered
  size="middle"
/>}
      <Table
        dataSource={prepareTableDataquarter(data)}
        columns={columns}
        size="small"
        bordered
        pagination={false}
        rowKey={(record, idx) => idx}
        scroll={{ x: 500, y: 250 }}
        className="border-table custom-table user-tbl scrollbar-hide custom-scrollbar"
        style={{ width: "100%" }}
      />
    </div>
  );
};

export const prepareTableData = (tiers) => {
  // console.log(tiers)
  // Get unique ranges
  const ranges = {};

  tiers.forEach((tier) => {
    const rangeKey = `${tier.lower_limit}-${tier.upper_limit}`;
    if (!ranges[rangeKey]) {
      ranges[rangeKey] = {
        key: rangeKey,
        range: `${tier.lower_limit.toFixed(2)}% - ${tier.upper_limit.toFixed(
          2
        )}%`,
        brandGCR: null,
        brandScrubbed: null,
        genericScrubbed: null,
      };
    }

    if (tier.category === "Brand" && tier.parameter === "GCR") {
      ranges[rangeKey].brandGCR = tier.rebate_value;
    } else if (tier.category === "Brand" && tier.parameter === "Scrubbed GCR") {
      ranges[rangeKey].brandScrubbed = tier.rebate_value;
    } else if (
      tier.category === "OneStop" &&
      tier.parameter === "Scrubbed GCR"
    ) {
      ranges[rangeKey].genericScrubbed = tier.rebate_value;
    }
  });

  return Object.values(ranges);
};

export const TooltipTable = ({ data }) => {
  const columns = [
    {
      title: "Range (%)",
      dataIndex: "range",
      key: "range",
      align: "center",
      width: 200,
    },
    // {
    //   title: "Brand - GCR",
    //   dataIndex: "brandGCR",
    //   key: "brandGCR",
    //   align: "center",
    //   render: (val) => (val !== null ? `${val}%` : "-"),
    //   width: 120
    // },
    {
      title: "Brand - Scrubbed GCR",
      dataIndex: "brandScrubbed",
      key: "brandScrubbed",
      align: "center",
      render: (val) => (val !== null ? `${val}%` : "-"),
      width: 160,
    },
    {
      title: "Generic - Scrubbed GCR",
      dataIndex: "genericScrubbed",
      key: "genericScrubbed",
      align: "center",
      render: (val) => (val !== null ? `${val}%` : "-"),
      width: 170,
    },
  ];

  return (
    <div
      className="overflow-x-auto scrollbar-hide"
      style={{ maxWidth: "100%" }}
    >
      <Table
        dataSource={prepareTableData(data)}
        columns={columns}
        size="small"
        bordered
        pagination={false}
        rowKey={(record, idx) => idx}
        scroll={{ x: 500, y: 250 }}
        className="border-table custom-table user-tbl scrollbar-hide custom-scrollbar"
        // style={{
        //   width: "100%",
        //   maxWidth: 600,
        // }}
        style={{ width: "100%" }}
      />
    </div>
  );
};

export const SGCRTooltipTable = ({ data, flag }) => {
  const columns = [
    {
      title: "Range (%)",
      dataIndex: "range",
      key: "range",
      align: "center",
      width: 200,
    },
    {
      title: "Brand - Scrubbed GCR",
      dataIndex: "brandScrubbed",
      key: "brandScrubbed",
      align: "center",
      render: (val) => (val !== null ? `${val}%` : "-"),
      width: 160,
    },
    {
      title: "Generic - Scrubbed GCR",
      dataIndex: "genericScrubbed",
      key: "genericScrubbed",
      align: "center",
      render: (val) => (val !== null ? `${val}%` : "-"),
      width: 170,
    },
  ];
  const sgcrData= [
  {
    key: "sgcr",
    term: "SGCR",
    description: (
      <>
        Scrubbed Generic Compliance Ratio. <br/>Generic Rx $ divided by Total Rx $ (Not including GLP-1, Specialty or HIV).
      </>
    ),
  }
]
const sgcrColumn = [
   {
    title: null,
    dataIndex: "term",
    key: "term",
    render: (text) => (
      <span className="font-medium text-black">{text}</span>
    ),
  },
   {
    title: null,
    dataIndex: "description",
    key: "description",
    render: (text) => (
      <span className="text-sm text-black">{text}</span>
    ),
  },
]

  return (
    <div
      className="overflow-x-auto scrollbar-hide bg-white rounded-md"
      style={{ maxWidth: "100%" }}
    >
      { flag == "SGCR" ?
      // <div className="flex gap-4 items-center px-4 pt-2">
      // <div className="text-gray-800 min-w-[50px] ">
      //   SGCR :
      // </div>
      // <div style={{ whiteSpace: "pre-line",marginBottom:"-10px" }} className=" flex items-center text-sm text-gray-800 bg-white  rounded-md">
      //      {`Scrubbed Generic Compliance Ratio. \nGeneric Rx $ divided by Total Rx $ (Not including GLP-1, Specialty or HIV)`}
      // </div>
      // </div>
      <Table
        columns={sgcrColumn}
        dataSource={sgcrData}
        pagination={false}
        showHeader={false}
        bordered
        size="middle"
      />
      :<></>}
      <Table
        dataSource={prepareTableData(data)}
        columns={columns}
        size="small"
        bordered
        pagination={false}
        rowKey={(record, idx) => idx}
        scroll={{ x: 500, y: 250 }}
        className="border-table custom-table user-tbl scrollbar-hide custom-scrollbar"
        // style={{
        //   width: "100%",
        //   maxWidth: 600,
        // }}
        style={{ width: "100%" }}
      />
    </div>
  );
};

export const prepareGPRTableData = (tiers) => {
  // console.log(tiers)
  // Get unique ranges
  const ranges = {};

  tiers.forEach((tier) => {
    const rangeKey = `${tier.lower_limit}-${tier.upper_limit}`;
    if (!ranges[rangeKey]) {
      ranges[rangeKey] = {
        key: rangeKey,
        range: `${tier.lower_limit.toFixed(2)}% - ${tier.upper_limit.toFixed(
          2
        )}%`,
        brandGCR: null,
        brandScrubbed: null,
        genericScrubbed: null,
      };
    }

    if (tier.category === "Brand" && tier.parameter === "GPR") {
      ranges[rangeKey].brandGPR = tier.rebate_value;
    } else if (tier.category === "OneStop" && tier.parameter === "GPR") {
      ranges[rangeKey].genericGPR = tier.rebate_value;
    }
  });

  return Object.values(ranges);
};

export const GPRTooltipTable = ({ data, flag }) => {
  const brandData = data?.filter(
  (item) => item?.category === "Brand"
);

const genericData = data?.filter(
  (item) => item?.category === "OneStop"
);
const formatRange = (lower, upper) => {
  if (upper >= 999) return `${lower.toFixed(2)}%+`;
  return `${lower.toFixed(2)}% - ${upper.toFixed(2)}%`;
};

const brandTableData = brandData?.map((item, index) => ({
  key: index,
  range: formatRange(item.lower_limit, item.upper_limit),
  rebate: `${item.rebate_value}%`,
}));

const genericTableData = genericData?.map((item, index) => ({
  key: index,
  range: formatRange(item.lower_limit, item.upper_limit),
  rebate: `${item.rebate_value}%`,
}));
  const columns = [
    {
      title: "Range (%)",
      dataIndex: "range",
      key: "range",
      align: "center",
      render: (val) => <span style={{ whiteSpace: "nowrap" }}>{val}</span>,
    },
    {
      title: "Brand GPR",
      dataIndex: "brandGPR",
      key: "brandGPR",
      align: "center",
      render: (val) => (val !== null && val != undefined ? `${val}%` : "-"),
    },
    {
      title: "Generic GPR",
      dataIndex: "genericGPR",
      key: "genericGPR",
      align: "center",
      render: (val) => (val !== null && val != undefined ? `${val}%` : "-"),
    },
  ];
    const gprData= [
  {
    key: "gpr",
    term: "GPR",
    description: (
      <>
        Generic Purchase Ratio. 
        <br/> This metric is calculated by dividing your total spend on generic tablets and capsules by the total number of generic tablets and capsules dispensed.
        <br/> The information used to calculate this figure is obtained through a data consent form submitted to McKesson, which authorizes them to access and review your dispensing data.
      </>
    ),
  }
]
const gprColumn = [
   {
    title: null,
    dataIndex: "term",
    key: "term",
    render: (text) => (
      <span className="font-medium text-black">{text}</span>
    ),
  },
   {
    title: null,
    dataIndex: "description",
    key: "description",
    render: (text) => (
      <span className="text-sm text-black">{text}</span>
    ),
  },
]
const brandColumns = [
  {
    title: "Brand GPR %",
    children: [
      {
        title: "Range %",
        dataIndex: "range",
        key: "range",
        align: "center",
      },
      {
        title: "Brand Rebate %",
        dataIndex: "rebate",
        key: "rebate",
        align: "right",
      },
    ],
  },
];

const genericColumns = [
  {
    title: "Generic GPR %",
    children: [
      {
        title: "Range %",
        dataIndex: "range",
        key: "range",
        align: "center",
      },
      {
        title: "Generic Rebate %",
        dataIndex: "rebate",
        key: "rebate",
        align: "right",
      },
    ],
  },
];

  return (
    <div
      className="overflow-x-auto scrollbar-hide bg-white rounded-md"
      style={{ maxWidth: "100%",maxHeight:"90vh" }}
    >
      { flag == "GPR" ?
      <Table
        columns={gprColumn}
        dataSource={gprData}
        pagination={false}
        showHeader={false}
        bordered
        size="middle"
      />
      :<></>}
      <div>
    <Table
      columns={brandColumns}
      dataSource={brandTableData}
      pagination={false}
      size="small"
      bordered
      rowKey={(record, idx) => idx}
      className="border-table custom-table user-tbl"
      style={{ width: "auto", minWidth: 300, }}
    />
  </div>

  {/* Generic Table */}
  <div>
    <Table
      columns={genericColumns}
      dataSource={genericTableData}
      pagination={false}
      size="small"
      bordered
      rowKey={(record, idx) => idx}
      className="border-table custom-table user-tbl"
      style={{ width: "auto", minWidth: 300, }}
    />
  </div>

    {/* <Table
      dataSource={prepareGPRTableData(data)}
      columns={columns}
      size="small"
      bordered
      pagination={false}
      rowKey={(record, idx) => idx}
      className="border-table custom-table user-tbl"
      style={{ width: "auto", minWidth: 300 }}
    /> */}
    </div>
  );
};

const CalculationModal = ({
  isVisible,
  onClose,
  data,
  dropdownOptions,
  fetchCalculationData,
  selectedGcr,
  setSelectedGcr,
  isloading,
  month,
  fetchgprPercentage,
  setMonth,
  selectedPharmacies,
  setCalculatedData,
  setIsLoading,
}) => {
  const [selectedfilter, setselectedfilter] = useState("month");
  const [selectedOption, setSelectedOption] = useState("");
  const [gcrChange, setGcrChange] = useState(false);
  const [preGcrDropdownData, setPreGcrDropdownData] = useState([]);
  const [genericInputVal, setGenericInputVal] = useState("");
  const [brandInputVal, setBrandInputVal] = useState("");
  const [brandEdit,setBrandEdit] = useState(false);
  const [genericEdit,setGenericEdit] = useState(false);
  const [popUpOpen,setPopUpOpen] = useState(false)
  const [isInputColumnVisible,setIsInputColumnVisible] = useState(false)
  const [valuesAll,setValuesAll] = useState({BrandRx:0,genericRx:0})
  const [brandAndGenValues,setBrandAndGenValues] = useState({BrandRx:0,genericRx:0})
  const [estimateColumnVisible,setEstimateVisible] = useState(true)
  const [advancedOn, setAdvancedOn] = useState(false);
  const [advancedMonthlyCalc, setAdvancedMonthlyCalc] = useState(false);
  const [isMonthlyBrandUpdate,setIsMonthlyBrandUpdate] = useState(false);
  const [isMonthlyGenUpdate,setMonthlyGenUpDate] = useState(false);

  const isMobile = window.innerWidth <= 768;
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // Restore on unmount
    };
  }, [isVisible]);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [year, setYear] = useState(new Date().getFullYear());
  const getOrdinalSuffix = (num) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = num % 100;
    return suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
  };
  const generateHeaderData = () => {
    const currentDate = new Date();
    const monthData = [];
    const quarterData = [];

    // Generate last 6 months data
    // for (let i = 0; i < 7; i++) {
    //   const date = new Date(currentDate);
    //   date.setMonth(date.getMonth() - i);
    //   const month = date.getMonth();
    //   const year = date.getFullYear();

    //   monthData.push({
    //     label: `${months[month]} ${year}`,
    //     value: `${month + 1}`,
    //     key: `${months[month]} ${year}`
    //   });
    // }
    const currentMonth = currentDate.getMonth(); // 0-based (0 = Jan)
    const currentYear = currentDate.getFullYear();
    for (let i = 11; i >= 0; i--) {
      const date = new Date(currentDate);
      date.setMonth(date.getMonth() - i);

      const month = date.getMonth(); // 0-based
      const year = date.getFullYear();
      monthData.push({
        label: `${months[month]} ${year}`,
        value: `${month + 1}`,
        key: `${months[month]} ${year}`,
      });
    }
    for (let i = 0; i < 4; i++) {
      const date = new Date(currentDate);
      date.setMonth(date.getMonth() - i * 3);
      const quarter = Math.floor(date.getMonth() / 3) + 1;
      const year = date.getFullYear();

      quarterData.push({
        label: `${quarter}${getOrdinalSuffix(quarter)} Quarter ${year}`,
        value: `${quarter}`,
        key: `${quarter}${getOrdinalSuffix(quarter)} Quarter ${year}`,
      });
    }
    return {
      month: monthData.reverse(),
      quarter: quarterData,
    };
  };
  const getHeaderdata = generateHeaderData();
  const descriptionLabels = [
    { key: "totalRx", label: "Total RX Spend" },
    { key: "genericRx", label: "Generic RX Spend" },
    { key: "brandRx", label: "Brand RX Spend" },
    ...(selectedfilter == "month"
      ? [
          { key: "rebateableBrand", label: "Rebateable Brand" },
          { key: "rebateableGeneric", label: "Rebateable Generic" },
          // { key: 'adjTotal', label: "ADJ Total" },
          // { key: "sgcrPct", label: "SGCR %" },
          {
            key: "sgcrPct",
            label: (
              <>
                SGCR %
                {/* <Tooltip
                title={
                <div className="tooltip-table-wrapper">
                  <TooltipTable data={dropdownOptions} />
                 </div>
                }
                placement="top"
                color="#fff"
                autoAdjustOverflow={true}
                // overlayInnerStyle={{
                //   color: "#000",
                //   padding: 0,
                //   // maxHeight: 250,
                //   // overflowY: "auto",
                //   // width:500,
                //   // maxWidth: 'none',
                //   maxWidth: '500px',
                //   borderRadius:20
                // }}
                overlayClassName="tooltip-table-wrapper"
                className="custom-scroll-hidden"
              >
                <InfoCircleOutlined
                  style={{
                    marginLeft: 6,
                    color: "#1890ff",
                    cursor: "pointer",
                    fontSize: 14,
                  }}
                />
              </Tooltip> */}
                <Tooltip
                  placement="top"
                  color="transparent"
                  overlayInnerStyle={{
                    padding: 0,
                    boxShadow: "none", // ✅ shadow remove
                    background: "transparent",
                  }}
                  title={
                    <div className="w-[300px] md:w-[600px]">
                      <TooltipTable data={dropdownOptions} />
                    </div>
                  }
                >
                  <InfoCircleOutlined
                    style={{
                      marginLeft: 6,
                      color: "#1890ff",
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                  />
                </Tooltip>
              </>
            ),
          },

          { key: "rebateBrand", label: "Rebate Brand ($)" },
          { key: "rebateGeneric", label: "Rebate Generic ($)" },
          { key: "rebateTotal", label: "Rebate Total ($)" },
          { key: "rebatePercBrand", label: "Rebate Percentage Brand" },
          { key: "rebatePercGeneric", label: "Rebate Percentage Generic" },
        ]
      : []),

    ...(selectedfilter !== "month"
      ? [
          {
            key: "gcrPct",
            label: (
              <>
                GCR %
                <Tooltip
                  placement="top"
                  color="transparent"
                  overlayInnerStyle={{
                    padding: 0,
                    boxShadow: "none", // ✅ shadow remove
                    background: "transparent",
                  }}
                  title={
                    <div style={{ width: 600 }}>
                      <QuarterTooltipTable data={dropdownOptions} />
                    </div>
                  }
                >
                  <InfoCircleOutlined
                    style={{
                      marginLeft: 6,
                      color: "#1890ff",
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                  />
                </Tooltip>
              </>
            ),
          },
          { key: "cogsPct", label: "COGs %" },
          { key: "cogsImpact", label: "COGs Impact",render: (val) => (val !== null && val !== undefined ? `$ ${val}` : "-") },
        ]
      : []),
  ]
  // .filter(
  // (item) =>
  //   item.key !== "cogsImpact" ||
  //   data?.inputs?.cogsImpact !== undefined
// );
  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") {
      return "$ 0.00";
    }
    const number = typeof value === "number" ? value : parseFloat(value);
    return `$ ${Math.abs(number).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const formatPercent = (value) => {
    if (value === null || value === undefined || value === "") {
      return "0 %";
    }
    return `${Math.abs(value)}%`;
  };

  const getColor = (val) => (parseFloat(val) < 0 ? "red" : "inherit");

  const columns = [
    {
      title: "Description",
      dataIndex: "label",
      key: "label",
      align: "left",
    },
    {
      title: "Current",
      dataIndex: "current",
      key: "current",
      align: "right",
    },
     ...(estimateColumnVisible
    ? [
    {
      title: "Estimate",
      dataIndex: "estimate",
      key: "estimate",
      align: "right",
    },]:[]),
     ...(isInputColumnVisible
    ? [
        {
          title: "Inputs",
          dataIndex: "inputs",
          key: "inputs",
          align: "right",
        },
      ]
    : []),
    {
      title: "Change",
      dataIndex: "change",
      key: "change",
      align: "right",
    },
  ];
  const quarterColumn = [
    {
      title: "Description",
      dataIndex: "label",
      key: "label",
      align: "left",
    },
    {
      title: "Current",
      dataIndex: "current",
      key: "current",
      align: "right",
    },
     ...(estimateColumnVisible
    ? [
    {
      title: "Estimate",
      dataIndex: "estimate",
      key: "estimate",
      align: "right",
    },]:[]),
     ...(isInputColumnVisible
    ? [
        {
          title: "Inputs",
          dataIndex: "inputs",
          key: "inputs",
          align: "right",
        },
      ]
    : []),
    {
      title: "Change",
      dataIndex: "change",
      key: "change",
      align: "right",
    },
    
  ];
  const handleGcrChange = (item) => {
    const data = {
      selectedGcr: item,
      selectedOption: selectedOption,
      selectedfilter: selectedfilter,
      year: selectedOption?.year ?? year,
    };
    setSelectedGcr(item);
    setGcrChange(true);
    fetchCalculationData(data);
    setAdvancedOn(false)
    setAdvancedMonthlyCalc(false)
    setBrandInputVal("");
    setGenericInputVal("");
    setBrandEdit(false);
    setGenericEdit(false)
    setValuesAll({BrandRx:0,genericRx:0})
    setBrandAndGenValues({BrandRx:0,genericRx:0})
    setIsInputColumnVisible(false)
    setEstimateVisible(true)
    // fetchgprPercentage(selectedfilter, data)
  };

  const labelName = selectedfilter == "month" ? "sgcrPct" : "gcrPct";
  const filterDropdownLIstRaw = dropdownOptions.filter(
    (val) => val?.lower_limit >= (data?.estimate?.[labelName] ?? 0)
  );

  const getMonthlyAdvancedData = async (genericValue, brandValue, targetPct) => {
    // console.log(brandDelta,"   ", genericDelta, "     ",targetPct, "brandeeletss")
    setIsLoading(true);
    const payload = {
      accounts: selectedPharmacies,
      year: year,
      month: selectedOption?.value,
      // targetPct: targetPct,
      genericDelta: Number(genericValue),
      brandDelta: Number(brandValue),
    };
    try {
      const response = await axiosInstance.post(
        "api/v2/users/gcr/monthly-calculator",
        payload
      );
      setCalculatedData(response?.data);
      setIsInputColumnVisible(true)
      setPopUpOpen(false)
      setEstimateVisible(false)
    } catch (error) {
      console.log(error, "Erroror");
    } finally {
      setIsLoading(false);
      setIsMonthlyBrandUpdate(false)
      setMonthlyGenUpDate(false)
      setBrandAndGenValues({BrandRx: Number(brandValue),
        genericRx: Number(genericValue)})
    }
  };
  const getQuarterlyData = async (genericValue, brandValue, targetPct) => {
    // console.log(brandDelta,"   ", genericDelta, "     ",targetPct, "brandeeletss")
    setIsLoading(true);
    const payload = {
      accounts: selectedPharmacies,
      year: year,
      quarter: selectedOption?.value,
      targetPct: targetPct,
      genericDelta: Number(genericValue),
      brandDelta: Number(brandValue),
    };
    try {
      const response = await axiosInstance.post(
        "api/v2/users/gcr/quarterly-calculator",
        payload
      );
      setCalculatedData(response?.data);
      setIsInputColumnVisible(true)
      setPopUpOpen(false)
      setEstimateVisible(false)
    } catch (error) {
      console.log(error, "Erroror");
    } finally {
      setIsLoading(false);
      setBrandEdit(false)
      setGenericEdit(false)
      setValuesAll({BrandRx: Number(brandValue),
        genericRx: Number(genericValue)})
    }
  };
  const filterDropdownLIst = gcrChange
    ? preGcrDropdownData
    : filterDropdownLIstRaw?.length > 0
    ? Array.from(
        new Map(
          filterDropdownLIstRaw.map((item) => [item.lower_limit, item])
        ).values()
      )
    : [dropdownOptions[dropdownOptions.length - 1]];

  // useEffect(() => {
  //   if (!gcrChange) {
  //     setPreGcrDropdownData(filterDropdownLIst);
  //   }
  // }, [gcrChange, filterDropdownLIst]);

  // console.log(selectedOption,"selectedopttionn")
  useEffect(() => {
    if (!gcrChange) {
      setPreGcrDropdownData(
        filterDropdownLIstRaw?.length > 0
          ? Array.from(
              new Map(
                filterDropdownLIstRaw.map((item) => [item.lower_limit, item])
              ).values()
            )
          : [dropdownOptions[dropdownOptions.length - 1]]
      );
    }
  }, [data, selectedfilter, dropdownOptions]);

  const dataSource = descriptionLabels.map((item, index) => {
    const isPercent =
      item.key === "sgcrPct" ||
      item.key === "gcrPct" ||
      item.key === "rebatePercGeneric" ||
      item.key === "rebatePercBrand" ||
      item.key == "cogsPct";
    return {
      key: index,
      label: item.label,
      current: isPercent
        ? formatPercent(data?.current?.[item.key])
        : item.key === "rebateBrand"
        ? formatCurrency(data?.current?.rebateDollars?.brand)
        : item.key === "rebateGeneric"
        ? formatCurrency(data?.current?.rebateDollars?.generic)
        : item.key === "rebateTotal"
        ? formatCurrency(data?.current?.rebateDollars?.total)
        : formatCurrency(data?.current?.[item.key]),
      estimate:
        item.key === "sgcrPct" || item.key === "gcrPct" ? (
          <Select
            onChange={handleGcrChange}
            placeholder={"Select GCR"}
            style={{ width: "90px" }}
            value={`${Math.floor(data?.estimate?.[item.key] || 0)}%`}
            defaultValue={data?.estimate?.[item.key]}
            size="large"
          >
            {filterDropdownLIst.map((val) => {
              return (
                <Option key={val?.lower_limit} value={val?.lower_limit}>
                  {val?.lower_limit}%
                </Option>
              );
            })}
          </Select>
        ) : item.key === "rebatePercBrand" ? (
          formatPercent(data?.estimate?.rebatePercBrand)
        ) : item.key === "rebatePercGeneric" ? (
          formatPercent(data?.estimate?.rebatePercGeneric)
        ) : isPercent ? (
          formatPercent(data?.estimate?.[item.key])
        ) : item.key === "rebateBrand" ? (
          formatCurrency(data?.estimate?.rebateDollars?.brand)
        ) : item.key === "rebateGeneric" ? (
          formatCurrency(data?.estimate?.rebateDollars?.generic)
        ) : item.key === "rebateTotal" ? (
          formatCurrency(data?.estimate?.rebateDollars?.total)
        ) : (
          formatCurrency(data?.estimate?.[item.key])
        ),
      change: (
        <span style={{ color: getColor(data?.change?.[item.key]) }}>
          {isPercent
            ? formatPercent(data?.change?.[item.key])
            : // ? `${Math.abs(parseFloat(data?.change?.[item.key] || 0).toFixed(2))}%`
            item.key === "rebateBrand"
            ? formatCurrency(data?.change?.rebateDollars?.brand)
            : item.key === "rebateGeneric"
            ? formatCurrency(data?.change?.rebateDollars?.generic)
            : item.key === "rebateTotal"
            ? formatCurrency(data?.change?.rebateDollars?.total)
            : formatCurrency(data?.change?.[item.key])}
        </span>
      ),
      inputs: (
        selectedfilter === "month" ? 
        <span style={{ color: getColor(data?.inputs?.[item.key]) }}>
          {isPercent ? (
            formatPercent(data?.inputs?.[item.key])
          ) : item.key === "genericRx" ? 
          (
              isMonthlyGenUpdate ? (
                <div className="flex justify-end items-center gap-2">
                  <input
                    type="number"
                    placeholder="Enter value"
                    className="w-24 px-2 py-1 border rounded text-sm text-right"
                    value={brandAndGenValues?.genericRx}
                    onChange={(e) => setBrandAndGenValues({genericRx:e.target.value,BrandRx:brandAndGenValues?.BrandRx})}
                  />
                  <button
                    className="px-3 py-1 text-sm !bg-[#001997] hover:!bg-[#061561] text-white border-none hover:!text-white"
                    onClick={() =>
                      getMonthlyAdvancedData(
                        brandAndGenValues?.genericRx,
                        brandAndGenValues?.BrandRx,
                        data?.estimate?.["sgcrPct"]
                      )
                    }
                  >
                    Save
                  </button>
                </div>
              )
          :
          <div className="flex justify-end items-center gap-2">
            <span style={{ color: getColor(brandAndGenValues?.genericRx)}}>{formatCurrency(brandAndGenValues?.genericRx || 0)}</span>
            <EditOutlined className="text-[#000833]"
               onClick={() =>
                 setMonthlyGenUpDate(true)
               }
               style={{ fontSize: 16, cursor: "pointer" }}/>   

          </div>
          ) : item.key === "brandRx" ? (
            isMonthlyBrandUpdate ? (
            <div className="flex justify-end items-center gap-2">
              <input
                type="number"
                placeholder="Enter value"
                className="w-24 px-2 py-1 border rounded text-sm text-right"
                value={brandAndGenValues?.BrandRx}
                onChange={(e) => setBrandAndGenValues({genericRx:brandAndGenValues?.genericRx,BrandRx:e.target.value})}
              />
              <button
                className="px-3 py-1 text-sm !bg-[#001997] hover:!bg-[#061561] text-white border-none hover:!text-white"
                onClick={() =>
                  getMonthlyAdvancedData(
                    brandAndGenValues?.genericRx,
                    brandAndGenValues?.BrandRx,
                    data?.estimate?.["gcrPct"]
                  )
                }
              >
                Save
              </button>
            </div>
            ):
            <div className="flex justify-end items-center gap-2">
            <span style={{ color: getColor(brandAndGenValues?.BrandRx)}}>{formatCurrency(brandAndGenValues?.BrandRx || 0)}</span>
            <EditOutlined className="text-[#000833]"
              onClick={() =>
                setIsMonthlyBrandUpdate(true)
              }
              style={{ fontSize: 16, cursor: "pointer" }}/>
            </div>
          ) : (
            formatCurrency(data?.inputs?.[item.key])
          )}
        </span>
        :
        <span style={{ color: getColor(data?.inputs?.[item.key]) }}>
          {isPercent ? (
            formatPercent(data?.inputs?.[item.key])
          ) : item.key === "genericRx" ? 
          (
              genericEdit ? (
                <div className="flex justify-end items-center gap-2">
                  <input
                    type="number"
                    placeholder="Enter value"
                    className="w-24 px-2 py-1 border rounded text-sm text-right"
                    value={valuesAll?.genericRx}
                    onChange={(e) => setValuesAll({genericRx:e.target.value,BrandRx:valuesAll?.BrandRx})}
                  />
                  <button
                    className="px-3 py-1 text-sm !bg-[#001997] hover:!bg-[#061561] text-white border-none hover:!text-white"
                    onClick={() =>
                      getQuarterlyData(
                        valuesAll?.genericRx,
                        valuesAll?.BrandRx,
                        data?.estimate?.["gcrPct"]
                      )
                    }
                  >
                    Save
                  </button>
                </div>
              )
          :
          <div className="flex justify-end items-center gap-2">
            <span style={{ color: getColor(valuesAll?.genericRx)}}>{formatCurrency(valuesAll?.genericRx || 0)}</span>
            <EditOutlined className="text-[#000833]"
               onClick={() =>
                 setGenericEdit(true)
               }
               style={{ fontSize: 16, cursor: "pointer" }}/>   

          </div>
          ) : item.key === "brandRx" ? (
            brandEdit ? (
            <div className="flex justify-end items-center gap-2">
              <input
                type="number"
                placeholder="Enter value"
                className="w-24 px-2 py-1 border rounded text-sm text-right"
                value={valuesAll?.BrandRx}
                onChange={(e) => setValuesAll({BrandRx:e.target.value,genericRx:valuesAll?.genericRx})}
              />
              <button
                className="px-3 py-1 text-sm !bg-[#001997] hover:!bg-[#061561] text-white border-none hover:!text-white"
                onClick={() =>
                  getQuarterlyData(
                    valuesAll?.genericRx,
                    valuesAll?.BrandRx,
                    data?.estimate?.["gcrPct"]
                  )
                }
              >
                Save
              </button>
            </div>
            ):
            <div className="flex justify-end items-center gap-2">
            <span style={{ color: getColor(valuesAll?.BrandRx)}}>{formatCurrency(valuesAll?.BrandRx || 0)}</span>
            <EditOutlined className="text-[#000833]"
              onClick={() =>
                setBrandEdit(true)
              }
              style={{ fontSize: 16, cursor: "pointer" }}/>
            </div>
          ) : (
            formatCurrency(data?.inputs?.[item.key])
          )}
        </span>
      ),
    };
  });

  const handleChange = (value) => {
    setselectedfilter(value);
    const defaultOption =
      value === "month" ? getCurrentMonthOption() : getCurrentQuarterOption();
    setSelectedOption(defaultOption);
    setBrandInputVal("");
    setGenericInputVal("");
    if (value == "month") {
    }
    const [, optionYear] = defaultOption.label.split(" ");
  };
  const getCurrentMonthOption = () => {
    const now = dayjs();
    const label = now.format("MMM YYYY"); // Jan 2026
    const monthValue = now.format("M"); // 1
    const year = now.format("YYYY"); // 2026

    return {
      key: label,
      label: label,
      value: monthValue,
      year: year,
    };
    // const currentDate = new Date();
    // const currentMonthIndex = currentDate.getMonth();
    // const currentYear = currentDate.getFullYear().toString(); // e.g., "2025"
    // const monthIndex = month - 1 || currentMonthIndex;

    // const months = [
    //   "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    //   "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
    // ];
    // const currentMonth = (months[monthIndex]); // "Jul"
    // return (
    //   getHeaderdata["month"].find(option => {
    //     const [monthName, year] = option.label.split(" ");
    //     return monthName === currentMonth && year === currentYear;
    //   }) || getHeaderdata["month"][0]
    // );
  };

  const getCurrentQuarterOption = () => {
    const currentDate = new Date();
    const quarter = Math.floor(currentDate.getMonth() / 3) + 1;
    const year = currentDate.getFullYear();
    const expectedLabel = `${quarter}${getOrdinalSuffix(
      quarter
    )} Quarter ${year}`;
    return (
      getHeaderdata["quarter"].find(
        (option) => option.label === expectedLabel
      ) || getHeaderdata["quarter"][0]
    );
  };
  useEffect(() => {
    if (!month || selectedfilter !== "month") return;

    const currentYear = new Date().getFullYear().toString();
    const monthIndex = month - 1;
    const monthName = months[monthIndex];

    const matchedOption = getHeaderdata["month"].find((option) => {
      const [labelMonth, labelYear] = option.label.split(" ");
      return labelMonth === monthName && labelYear === currentYear;
    });

    if (matchedOption) {
      // setSelectedView(matchedOption)
      setSelectedOption(matchedOption);
      setYear(currentYear);
    }
  }, [month, selectedfilter]);

  const handlemonth = (value) => {
    const select = getHeaderdata[selectedfilter].find(
      (item) => item.value === value
    );
    if (selectedfilter === "month") {
      const [, year] = select?.label?.split(" ") || "2024";
      setYear(year);
    } else if (selectedfilter === "quarter") {
      const [, , year] = select?.label?.split(" ") || ["", "", "2024"];
      setYear(year);
    }
    setSelectedOption(select);
    setBrandInputVal("");
    setGenericInputVal("");
    if (selectedfilter == "month") {
      // setMonth(select);
    }
  };
  const onChangeMonth = (date) => {
    if (!date) return;

    const label = date.format("MMM YYYY"); // Jan 2026
    const monthValue = date.format("M"); // 1
    const year = date.format("YYYY"); // 2026

    const option = {
      key: label,
      label: label,
      value: monthValue,
      year: year,
    };

    setSelectedOption(option);
  };

  useEffect(() => {
    const item = {
      selectedOption: selectedOption,
      selectedfilter: selectedfilter,
      year: selectedOption?.year ?? year,
    };
    setGcrChange(false);
    fetchCalculationData(item);
    setAdvancedOn(false)
    setAdvancedMonthlyCalc(false)
    setBrandEdit(false)
    setGenericEdit(false)
     setValuesAll({BrandRx:0,genericRx:0})
     setIsInputColumnVisible(false)
     setEstimateVisible(true)
    // }, [selectedOption, selectedfilter])
  }, [selectedOption]);

  useEffect(() => {
    const item = {
      selectedOption: selectedOption,
      selectedfilter: selectedfilter,
      year: selectedOption?.year ?? year,
    };
    setGcrChange(false);
    fetchgprPercentage(selectedfilter, item);
  }, [selectedfilter]);

  const disabledMonth = (current) => {
    const MIN_MONTH = dayjs("2025-01", "YYYY-MM");
    const MAX_MONTH = dayjs(); // always current month
    if (!current) return false;

    return (
      current.isBefore(MIN_MONTH, "month") ||
      current.isAfter(MAX_MONTH, "month")
    );
  };

  const stopAdvanCalc = ()=>{
    const item = {
      selectedOption: selectedOption,
      selectedfilter: selectedfilter,
      year: selectedOption?.year ?? year,
    };
    setGcrChange(false);
    fetchCalculationData(item);
    setIsInputColumnVisible(false)
    setEstimateVisible(true)
    setBrandEdit(false)
    setGenericEdit(false)
    setValuesAll({BrandRx:0,genericRx:0})
    setAdvancedMonthlyCalc(false);
    setBrandAndGenValues({BrandRx:0,genericRx:0});
    setMonthlyGenUpDate(false)
    setIsMonthlyBrandUpdate(false)
  }
  return (
    <div className="scrollbar-hide border-table align-middle justify-center">
      <Modal
        title={
          <span style={{ color: "#222", fontWeight: "700" }}>
            GCR Rebate Optimizer Tool
          </span>
        }
        open={isVisible}
        onCancel={() => {
          onClose();
          setselectedfilter("month");
          setSelectedOption(getCurrentMonthOption);
          setValuesAll({BrandRx:0,genericRx:0})
          setAdvancedOn(false)
          setAdvancedMonthlyCalc(false)
        }}
        footer={null}
        width={isMobile ? "90%" : "60%"}
        style={{ top: 80 }}
        // bodyStyle={{ maxHeight: '90vh', overflowY: 'auto', }}
        className="custom-scroll-hidden scrollbar-hide "
      >
        {
          selectedfilter === "month" && 
          (
        <div className="flex justify-end">
          <Button
             style={{width: 200, height: 41, marginTop:10,marginBottom:-10}}
             className="w-[150px] md:w-[150px] h-20 !bg-[#000833] hover:!bg-[#000833] text-white border-none hover:!text-white"
           >
              Advanced Calculator
              <Switch
                checked={advancedMonthlyCalc}
                  className={`${advancedMonthlyCalc ? "!bg-[#1100ff]" : "!bg-gray-300"}`}

                onChange={(checked) => {
                  setAdvancedMonthlyCalc(checked);
                
                  if (checked) {
                    getMonthlyAdvancedData(0,0,data?.estimate?.["sgcrPct"]);
                  }
                  else{
                    stopAdvanCalc()
                  }
                }}/>
          </Button>
        </div>
          )
        }
        {
          selectedfilter !== "month" && 
          (
        <div className="flex justify-end">
          <Button
             // icon={<ShoppingCartOutlined />}
             style={{width: 200, height: 41, marginTop:10,marginBottom:-10}}
            //  onClick={() => {
            //    // setIsInputColumnVisible(true);
            //   // setEstimateVisible(false)
            //   getQuarterlyData(0,0,data?.estimate?.["gcrPct"])
            //   //  setPopUpOpen(true)
            // }}
             className="w-[150px] md:w-[150px] h-20 !bg-[#000833] hover:!bg-[#000833] text-white border-none hover:!text-white"
           >
              Advanced Calculator
              <Switch
                checked={advancedOn}
                  className={`${advancedOn ? "!bg-[#1100ff]" : "!bg-gray-300"}`}

                onChange={(checked) => {
                  setAdvancedOn(checked);
                
                  if (checked) {
                    getQuarterlyData(0,0,data?.estimate?.["gcrPct"]);
                  }
                  else{
                    stopAdvanCalc()
                  }
                }}
  />
          </Button>
        </div>
          )
        }
        <div className="flex justify-end mt-5" style={{ marginBottom: -20 }}>
          <Select
            className="custom-select"
            style={{ width: 150, height: 41 }}
            suffixIcon={<DownOutlined style={{ color: "#fff" }} />}
            // allowClear
            value={selectedfilter}
            onChange={handleChange}
            options={[
              {
                value: "month",
                label: "Monthly",
              },
              {
                value: "quarter",
                label: "Quarterly",
              },
            ]}
            placeholder="Month | Year"
          />
          {selectedfilter === "month" ? (
            <DatePicker
              picker="month"
              onChange={onChangeMonth}
              defaultValue={dayjs()}
              value={
                selectedOption?.year
                  ? dayjs(selectedOption.label, "MMM YYYY")
                  : dayjs()
              }
              allowClear={false}
              style={{
                height: 41,
                width: 150,
              }}
              format="MMM YYYY"
              disabledDate={disabledMonth}
              inputReadOnly
              className="brand-month-picker "
              dropdownClassName="brand-month-dropdown"
              suffixIcon={<DownOutlined style={{ color: "#fff" }} />}
            />
          ) : (
            <Select
              className="custom-select"
              suffixIcon={<DownOutlined style={{ color: "#fff" }} />}
              style={{
                height: 41,
                width: 170,
              }}
              // allowClear
              value={selectedOption?.value}
              onChange={handlemonth}
              options={getHeaderdata[selectedfilter].map((item) => ({
                value: item.value,
                label: item.label,
                key: item.key,
              }))}
              placeholder="Month | Year"
            />
          )}
        </div>
        <div
          className="overflow-x-auto scrollbar-hide"
          style={{ maxWidth: "100%" }}
        >
          <Table
            dataSource={dataSource}
            loading={isloading}
            columns={selectedfilter === "month" ? columns : quarterColumn}
            className="border-table custom-table user-tbl scrollbar-hide"
            pagination={false}
            bordered
            scroll={{ x: "max-content", y: "400px" }}
            style={{ minWidth: "600px" }}
          />
        </div>
      </Modal>
      <AdvanCapitalModal
      isVisible={popUpOpen}
      onClose = {()=>setPopUpOpen(false)}
      getQuarterlyData={getQuarterlyData}
      targetPct={data?.estimate?.["gcrPct"]}
      setIsInputColumnVisible = {setIsInputColumnVisible}
      valuesAll = {valuesAll}
      />
    </div>
  );
};

export default CalculationModal;